import React from 'react';
import { Link } from 'react-router-dom';
import voxelaryLogo from '../../assets/Voxelary-Logo-final.png';

interface HoldingLayoutProps {
  children: React.ReactNode;
}

/** Minimal shell for the public holding site. Old PageLayout / marketing chrome is preserved elsewhere for later. */
const HoldingLayout: React.FC<HoldingLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-[#050a14] flex flex-col">
      <header className="fixed top-0 left-0 right-0 z-50">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-10 pt-6 pb-4 flex items-center justify-between">
          <Link to="/" aria-label="Voxelary Home" className="shrink-0">
            <img src={voxelaryLogo} alt="Voxelary" className="h-8 sm:h-9 w-auto object-contain" />
          </Link>
          <Link
            to="/contact"
            className="text-sm font-medium px-5 py-2.5 bg-white text-voxelary-900 hover:bg-white/90 transition-colors"
          >
            Get in Touch
          </Link>
        </div>
      </header>
      <main className="flex-1">{children}</main>
    </div>
  );
};

export { HoldingLayout };
